export  * from './app.component';
export * from './enftreport/index';
export * from './ongoingreport/index';
export * from './nhftreport/index';
export * from './PayrollDataActivityreport/index';
export * from './ErCoverageReport/index';
export * from './EmployeeEligibilityReport/index';
export * from './EmployeeDemographicsReport/index';
export * from './EmployeeBreakInServiceReport/index';
export * from './ControlGroup/index';
export * from './ApplicableLargeEmployee/index';
export * from './ApplicableLargeEmployeeDetails/index';
export * from './ListCustomer/index';
export * from './OnBoardingPersonalInformation/index';
export * from './OnBoardingCustomerInformation/index';
export * from './ClientPayroll/index';
export * from './AleDataUpload/index';
export * from './EmployeeSummaryReport/index';
export * from './LegalEntitiesReport/index';
export * from './InsuranceInfoReport/index';
export * from './AcaDataReport/index';
export * from './PayrollDataUpload/index';
export * from './InsuranceDataUpload/index';
export * from './OneZeroNineFourDataUpload/index';
export * from './OneZeroNineFiveDataUpload/index';
export * from './Original1095C/index';
export * from './layout/index';
export * from './dashboard/index';
export * from './login/index';
export * from './detail1094/index';
export * from './detail1095/index';
export * from './readytosubmitirs/index';



// WEBPACK FOOTER //
// ./src/app/index.ts